import React, { Fragment, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import AdminClubMembers from './screens/AdminClubMembers';
import AdminActivity from './screens/AdminActivity';
import Dashboard from './screens/Dashboard';
import Login from './screens/Login';
import Register from './screens/Register';
import AdminTiers from './screens/AdminTiers';

function App() {
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [user, setUser] = useState({});
  const [loggedIn, setLoggedIn] = useState(false);
  const [reset, setReset] = useState(false);

  const [token, setToken] = useState();
  // const sandbox = {
  //   clientId: 'AcDS7cearu2PCj0xv_FhsnOFCcu76MJEgBJ8o2mQQvefF1KlQV4XT6gfvsagqqE49thDDvEHb0dTcDUY',
  //   secret: 'EJ1E0TAdjtBwF9Ii4s6Z-DKrJLlDnK7fqvUkE-PSgSjI1eEBlrKsg_8QEGOxpsxA1d30HhwIPnA7XYcZ'
  // }
  const live = {
    clientId: 'Aak7DrkIoy9JZeosXSsn9oxo0TJEO61A1-Q4wdNszhsqks_syN3TymS30bBCtlh9DwNLhSMdtXDAtaLn',
    secret: 'EOCK9o1uGH0TMQPlXI35fYpjT9vZPHFmRnc8PbGQr6AD-T3bL-yXAMQMh232TBAClWw_dwxHBUGtK9fr'
  }
  const authBase64 = Buffer.from(`${live.clientId}:${live.secret}`).toString('Base64');

  useEffect(() => {
    const existingUser = localStorage.getItem('user');
    if (existingUser) {
      setUser(JSON.parse(existingUser))
      setLoggedIn(true)
      onGetAccessToken()
    }
  }, [])
  
  const onLogin = (email, password) => {
    setLoading(true)
    setLoginError('')

    const trimmedEmail = email.replace(/\s/g, '');
    fetch( '/api/users/login', {
      method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({email: trimmedEmail, password})
    })
      .then(res => res.json())
      .then(
        (result) => {
          if (result.success) {
            // user used temporary password
            setReset(true)
          } else if (result.error) {
            setLoginError('Incorrect email or password.')
            setLoading(false)
            setLoggedIn(false)
          } else {
            setUser(result)
            localStorage.setItem('user', JSON.stringify(result))
            setLoggedIn(true)
          }
          
          setLoading(false)
        },
        (error) => {
          console.log(error)
          setLoginError('Incorrect email or password.')
          setLoading(false)
          setLoggedIn(false)
        }
    )
  }

  // update user details from the Membership Dashboard
  const [dashboardAttemptError, setDashboardAttemptError] = useState('');
  const [showDashboardAccountDetails, setShowDashboardAccountDetails] = useState(false)
  const onSaveUserDetails = async (u) => {
    setShowDashboardAccountDetails(true);
    if (!loading) {
      // only perform action if API isn't already processing
      setLoading(true);
      u.id = user.id;
      if (u.prefix.replace(/\s/g, '') === '' || u.lastName.replace(/\s/g, '') === '' || u.email.replace(/\s/g, '') === '') {
        setDashboardAttemptError('Please fill out required fields.')
        setLoading(false);
      } else if (!u.email.includes('@')) {
        setDashboardAttemptError('All emails should include @.')
        setLoading(false);
      } else {
        try {
          const rawResponse = await fetch('/api/users', {
            method: 'PUT',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({user: u})
          });

          const content = await rawResponse.json();
          if (content.error) {
            setDashboardAttemptError(content.error);
            setLoading(false);
          } else {
            setShowDashboardAccountDetails(false);
            setLoading(false);
            setUser(content)
            localStorage.setItem('user', JSON.stringify(content))
          }
        } catch (error) {
          console.log(error)
        }  
      }
    }
  }

  const onLogout = () => {
    setUser({})
    localStorage.removeItem('user')
    setLoggedIn(false)
  }

  // reset password from the login screen
  const onResetPassword = (email, newpass) => {
    if (!loading) {
      setLoading(true)
      setLoginError('')

      const trimmedEmail = email.replace(/\s/g, '');
      fetch( '/api/users/change-password', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({email: trimmedEmail, password: newpass})
        })
        .then(res => res.json())
        .then(
          (result) => {
            setUser(result)
            localStorage.setItem('user', JSON.stringify(result))
            setLoggedIn(true)
            setLoading(false)
            setReset(false)
          },
          (error) => {
            console.log(error)
            setLoginError('Incorrect email or password.')
            setLoading(false)
            setLoggedIn(false)
          }
      )
    }
  }

  // change user password from the Membership Dashboard
  const [showDashboardPassword, setShowDashboardPassword] = useState(false)
  const [dashboardPasswordError, setDashboardPasswordError] = useState('')
  const onSaveNewPassword = async ({ existingPassword, newPassword }) => {
    setShowDashboardPassword(true)
    if (!loading) {
      setLoading(true)
      setDashboardPasswordError('')

      try {
        const rawResponse = await fetch(`/api/users/email/new-password`, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({existingPassword, newPassword, email: user.email})
        });

        const content = await rawResponse.json();
        if (content.error) {
          setDashboardPasswordError(content.error);
          setLoading(false);
        } else {
          setShowDashboardPassword(false);
          setLoading(false);
          setUser(content)
          localStorage.setItem('user', JSON.stringify(content))
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onCreateUser = (result) => {
    setUser(result)
    localStorage.setItem('user', JSON.stringify(result))
    setLoggedIn(true)
  }

  const onGetAccessToken = async () => {
    try {

      const access = await fetch(`https://api-m.paypal.com/v1/oauth2/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'Accept-Language': 'en_US',
          'Authorization': `Basic ${authBase64}`,
        },
        body: 'grant_type=client_credentials'
      });

      // const rawResponse = await fetch(`/api/subscriptions/paypal-auth`, {
      //   method: 'POST',
      //   headers: {
      //     'Accept': 'application/json',
      //     'Content-Type': 'application/json'
      //   }
      // });

      // const content = await rawResponse.json();
      // console.log(content)

      const accessJSON = await access.json();
      const accessToken = accessJSON.access_token;
      setToken(accessToken)

    } catch (err) {
      console.log(err)
    }
  }

  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/">
            {loggedIn && user.id ?
              <Redirect to="/dashboard" /> :
              <Login
                onLogin={onLogin}
                resetPassword={onResetPassword}
                loading={loading}
                loginError={loginError}
                reset={reset}>
              </Login>
            }
          </Route>
          <Route exact path="/register">
            {loggedIn ?
              <Redirect to="/dashboard" /> :
              <Register onCreateUser={onCreateUser}></Register>
            }
          </Route>
          {user !== {} &&
            <Fragment>
            <Route exact path="/dashboard">
              {/* Membership Dashboard */}
              <Dashboard
                user={user}
                token={token}
                detailsLoading={loading}
                dashboardAttemptError={dashboardAttemptError}
                showDashboardAccountDetails={showDashboardAccountDetails}
                onSaveUserDetails={onSaveUserDetails}
                dashboardPasswordError={dashboardPasswordError}
                showDashboardPassword={showDashboardPassword}
                onSaveNewPassword={onSaveNewPassword}
                onLogout={onLogout}>
              </Dashboard>
              </Route>
              {user.isAdmin &&
                <Fragment>
                  <Route exact path="/admin/members">
                    <AdminClubMembers user={user} token={token} onLogout={onLogout}></AdminClubMembers>
                  </Route>
                  <Route exact path="/admin/activity">
                    <AdminActivity user={user} token={token} onLogout={onLogout}></AdminActivity>
                  </Route>
                  <Route exact path="/admin/membership-tiers">
                    <AdminTiers user={user} token={token} onLogout={onLogout}></AdminTiers>
                  </Route>
                </Fragment>
              }
            </Fragment>
          }
        </Switch>
      </div>
    </Router>
  );
}

export default App;
